export default __webpack_public_path__ + "static/media/white-card.a95ec284.png";